module.exports = __webpack_public_path__ + "img/paynow.2fbd2e93.png";